@if (lang === 'en' || lang === 'EN') {
  <ion-content >
    <div class=WordSection1>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA;mso-bidi-font-weight:bold'>SHOP ACHAT offers you a shopping
        experience from your preferred place of business. The following is to ensure
        your satisfaction and understanding of the purchasing process of products and
        services offered by the businesses that use SHOP ACHAT, hereinafter referred to
      as (&quot;The Store&quot;). </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA;mso-bidi-font-weight:bold'>When you purchase a
        product or service from The Store located in the United States or Canada, SHOP
        ACHAT manages the online ordering system directly sourced on The Store's
        website. Your order goes through the SHOP ACHAT online ordering solution which
        collects payment on behalf of The Store via a secure payment gateway.<span
      style='mso-spacerun:yes'>  </span>All prices for products or services are offered
      by The Store’s respective currency and its applicable taxes. The products or
      services offered by The Store may be subject to fees per order and / or order
      processing fees which are non-refundable for each order placed via web or application.
      In several cases, these fees will be charged by The Store or SHOP ACHAT. In all
      cases, if you do not wish to pay these fees per order, you can place your
      orders by phone directly with The Store. All orders are subject to credit card
      approval and verification of the card holder’s name, billing postal code,
      billing address, card verification number (Cardholder Verification Value (CVV)
      code) and the same credit card presentation along with respective billing
    address at time of pickup and delivery. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>SHOP ACHAT Terms and Conditions </span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>SHOP ACHAT and The Store’s Terms and Conditions</span></b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'></span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif"'>THESE TERMS AND CONDITIONS OF USE MAY CHANGE
    FROM TIME TO TIME THUS ITS IMPORTANT THAT YOU KEEP YOURSELVES CURRENT WITH THE SHOP
    ACHAT TERMS &amp; CONDITIONS. BY USING SHOP ACHAT WEBSITE, APPLICATION, THE
    STORE’S MOBILE APP AND PRODUCTS/SERVICES YOU AKNOWLEDGE YOUR RESPONSIBILITIES
    AND ACCEPT THE FOLLOWING TERMS AND CONDITIONS SET FORTH BELOW. IF ANY OF THE
    FOLLOWING TERMS ARE NOT RESPECTED AND ACCEPTED FOR ANY REASON THEN YOU SHOULD
  NOT USE THE SERVICES OF SHOP ACHAT OR THE STORE.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif"'>BY ACCESSING, DOWNLOADING, INSTALLING OR
    OTHERWISE USING THIS APPLICATION, YOU AGREE AND ACCEPT THESE TERMS AND
    CONDITIONS. IF YOU DO NOT AGREE, DO NOT ACCESS, DOWNLOAD, INSTALL OR USE THE
    APPLICATION. IF YOU HAVE INSTALLED THE APPLICATION AND DO NOT AGREE TO THESE
    TERMS AND CONDITIONS, YOU MUST IMMMEDIATELY UNINSTALL THE APPLICATION. <span
  style='mso-spacerun:yes'> </span></span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>THESE TERMS AND CONDITIONS CONSTITUTE A LEGAL
    AGREEMENT BETWEEN YOU, SHOP ACHAT AND THE STORE (“AGREEMENT”). THIS AGREEMENT
  CONTAINS PROVISIONS THAT LIMIT THE LIABILITY OF SHOP ACHAT AND THE STORE.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>ELIGIBILITY </span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>THE APPLICATION MUST ONLY BE USED BY PEOPLE AGED
    FOURTEEN (14) YEARS OR OVER. IF YOU ARE 14 YEARS AND YOUNGER, YOU MUST
  IMMEDIATELY UNINSTALL THE APPLICATION AND STOP USING IT. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:2'><b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>COLLECTION, USE AND DISCLOSURE OF
  YOUR INFORMATION </span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:2'><b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>COLLECTION</span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>You agree that SHOP ACHAT and The Store may gather
    and use data about you, your device, software of your system and the application.
    This permits SHOP ACHAT and The Store to better address your preferences, by utilizing
    the application (Application), you acknowledge, agree and consent that SHOP
    ACHAT and The Store, and/or its affiliates and third party partners may gather,
    use and transmit the information you provide using the Application, and other
    information that identifies you personally collected through the use of the
    Application or specifically provided by you when you use the Application
    through registering for an account with SHOP ACHAT or The Store, or otherwise
    provided ( “INDIVIDUAL INFORMATION”) to encourage the improvement and delivery
  of products, offers, promotions or any other service.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Location information</span></b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>: With your consent, SHOP ACHAT
  and The Store collect location information through your use of the Application,
  including locating information collected through <span class=SpellE>geolocation</span>
  capabilities and similar capabilities of your device or mobile phone. The
  objective of collecting location information is to identify locations that are
  the closest to your immediate location and effectively use the features of the Application.
  We collect only the location information, if you agree, through a membership
  option, to receive some features of the Application and by enabling these capabilities
  on your mobile device. Once the membership is accepted, the application will
  continue to collect location information until you close the application or if
  you change the settings of your phone or other device to disable <span
class=SpellE>geolocation</span> capabilities or you change the settings of your
phone or other device to prevent the Application to collect your location
information. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>Use: </span></b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>INDIVIDUAL INFORMATION are used
for purposes such as improving the functionality and features of the Application
to answer your requests and messages, to conduct research on behaviour and/or
consumer interests, to improve our services or products, and to provide you
with information about our offers and special promotions in the store(s).</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>Disclosure: </span></b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>SHOP ACHAT and The Store can
share INDIVIDUAL INFORMATION with its affiliates, agents, business partners,
franchisees, stores and other third parties in the following ways: SHOP ACHAT
and The Store may disclose information about information you authorize to share
when you use the Application, visit the store, products that you view and that
you share the most frequently, and which parts of the store(s) you visit the
most; SHOP ACHAT and The Store may disclose INDIVIDUAL INFORMATION to provide
certain commercial services and communicate as authorized for commercial
services to be provided. SHOP ACHAT and The Store can disclose INDIVIDUAL
INFORMATION if required by law or if we believe in good faith that such action
is necessary to (i) comply with legal obligations, (ii) to protect or defend
our rights or property, (iii) act in urgent circumstances to protect the
personal safety of users of the Application or general public, or (iv) to
protect SHOP ACHAT and The Store against liability. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>Storage of information: </span></b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>SHOP ACHAT and The Store can
store all the information they collect (authorized or otherwise) in databases
owned and maintained by SHOP ACHAT, our subsidiaries, our suppliers, our
franchisees, our stores, our agents or our service providers. Using the
Application, you consent to the storage and transfer of your information as
described above.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>The collection of information: </span></b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>You cannot use the Application
without providing individual information. You can limit the Individual
Information collected by uninstalling the Application, turning it off or
preventing it from using <span class=SpellE>geolocation</span> capabilities, or
limiting some features or aspects of the Application through the capabilities
of any mobile device. <span style='mso-bidi-font-weight:bold'></span></span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Links to other websites: </span></b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>The Application may contain
references, links or interactions to other websites that are not operated when
controlled by SHOP ACHAT or The Store. The policies and procedures we describe
herein are not applicable to other websites. SHOP ACHAT or The Store assumes no
responsibility regarding the policies to protect individual information and
gathering information from these other websites.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>SENDING ORDERS </span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>This section applies to orders placed by you
  through the Application where this service is offered. The Store is owned and
  managed by an independent business owner(s): Although there may be a parent organization
  that operates and controls the Application, it is not responsible for The
  Store’s operations. Each store is fully and independently responsible for its
  legal and regulatory compliance with respect to any problem related to the
supply of products or services to you.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Orders</span></b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>: The purpose of ordering is to offer customers a
convenient way to create an order for products in advance and submit by
registering at a participating store. Before you order, you can create a
profile in the Application. Before submitting an order, you must register a
credit card (a “Credit Card”) on which your order payments will be processed. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Payment method</span></b><span style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>: SHOP ACHAT and The Store rely on the services of
independent suppliers to save your Credit Card and process SHOP ACHAT payments.
You understand and agree that when you register a Credit Card, SHOP ACHAT or
its independent providers can verify the validity of the registered Credit Card.
You also understand and agree that when placing an order at a store, The Store
is the merchant. To pick up your order at the counter or during delivery, you
must present the Credit Card used for payment as well as a photo ID. These
identity documents are essential in order to receive your order. SHOP ACHAT and
The Store reserve the right to not provide or deliver orders to anyone who
would not have these documents. YOU WARRANT THAT YOU HOLD ALL THE LEGAL RIGHTS
TO USE THE CREDIT CARDS YOU REGISTER.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Buying products</span></b><span style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>: When you order, you submit orders directly to a
participating Store and the contract for the supply of products or services will
be concluded between you and the Store that accepts your order. The location
where you pick up your products is responsible for preparing the products and
providing them to you.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>About the products</span></b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>: All products are subject to
availability at The Store where you collect your order. Some Stores do not
serve all products. The images of the products and packaging that appear in the
Application are shown as examples only and may not be identical to products or
packages you receive from The Store. The differences may be due to the color
display of your device or to other factors, such the supplier, the area where
the store is located, and etc. Each Store will update and maintain their suite
of products along with respective descriptions, titles, images and prices. Each
Store applies the prices as they are shown in the ordering feature and then
applies any taxes and additional costs required by law. Some offers and some
prices may not be available on all orders at all stores. If you discover an
error in the price of a product you are charged, please contact the Store where
you purchased the product to request a refund or a credit for the difference in
price.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Order processing</span></b><span style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>: Orders are processed through a service developed
and powered by SHOP ACHAT. In many cases, the Application’s fees and shipping
costs will be due and charged by SHOP ACHAT that offers a Service that is
different from the service provided by The Store. SHOP ACHAT offers an
independent service that the customer can choose to use to place an order from
The Store. In all cases, you can choose whether to use the SHOP ACHAT ordering
feature to place an order at The Store. If you do not wish to pay the fee for
use of the Application’s ordering feature, you can always place your order by
phone or in person directly with the desired store.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Send your order</span></b><span style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>: You can use the Application to create your order
and send it to The Store you choose. You only make your purchase when you
submit your order to The Store. Your Credit Card will not be charged until you
have agreed to send your order to The Store. Orders may be collected in person
at The Store or through The Store’s delivery or shipping service.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Payment</span></b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>: When you complete your order, you allow The Store
to process your total order. SHOP ACHAT or The Store’s payment service provider
will process the total amount of your order to the credit card you chose when
you created your order. You may receive an email confirmation informing your
order has been approved or that The Store has accepted and started to prepare
your order. The products belong to you once you have picked them up or received
them.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Confirmation: </span></b><span style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA;mso-bidi-font-weight:bold'>If you do not receive a
confirmation number (in the form of a confirmation page and / or an email)
after submitting the payment information, you have not completed the purchased.
If you experience an error or experience a service interruption after
submitting the payment information, it is your responsibility to confirm
whether or not your order has been placed via SHOP ACHAT or with The Store’s
customer service. Only you are aware of any problems that may have occurred
during the purchasing process. SHOP ACHAT and The Store cannot be held responsible
for any loss (monetary or otherwise) or any delay in the payment, order and delivery
of your order, even if you assumed that an order has been placed and you have
not received confirmation.</span><span style='font-size:10.0pt;font-family:
"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";mso-fareast-language:
EN-CA'></span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Cancelling your order</span></b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>: You can cancel your order prior
to confirming your payment on The Store’s website. However, once you have made
the payment, you will not be able to cancel it. If you wish to be reimbursed
for any reason, particularly if the products were not satisfactory or for any
other reason, please contact The Store, where you purchased the product for a
refund. Your legal rights in this regard are not affected by any of these terms.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>OFFERS IN THE APPLICATION </span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>You can receive promotional offers via the
APPLICATION.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>The following general conditions apply to the
  offers: The offer is subject to availability, at The Store only, until the
  expiry date; unless otherwise stated, each offer expires when the product is
  purchased, only one offer can be applied upon purchase at The Store, the offers
  are non-transferable and the offers cannot be exchanged for cash. In addition,
  specific conditions may apply to the offer featured in the Application and
  displayed with the offer. Not all offers that can be applied to <span
class=SpellE>pickup</span> or delivery orders. Any questions regarding the
offers should be addressed to The Store.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b style='mso-bidi-font-weight:normal'><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>LOYALTY PROGRAM IN THE
APPLICATION</span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>If the loyalty/reward Program is active, it is the
  property of The Store and is available to customers in collaboration with all
  participating stores. The Store may, at its sole discretion, suspend or
  terminate the Program without prior notice.&nbsp;In case of interruption or
  termination of the Program for any reason whatsoever, The Store and SHOP ACHAT will
  not be liable to members of the Program and will be automatically released from
  all claims by members in the event of the Program’s interruption, termination, change
  in Program’s terms of use or conditions, loss or exchange of points or any other
  issues arising from the Program’s operability, interruption or
termination.&nbsp;</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>The customer/member is subject to The Store’s
  loyalty program’s terms and conditions, rules, benefits, conditions of
  participation or the points/advantage dollars required to get rewards, in whole
  or in part, at any time and without notice, even if such changes may affect the
  value of accumulated points. If The Store’s loyalty program requires the
  customer to register their card to redeem the value of their rewards, then the
  customer must register, validate and accept their program’s terms and
  conditions found on the <span class=SpellE>The</span> Store’s website prior to linking
  their member’s program to The Store’s Application to use as a form of payment. To
  accumulate rewards/points/advantage dollars when making purchases, the user, <span
class=GramE>member</span> must log into their account to place an online order
on SHOP ACHAT or The Store’s Application. In no circumstance can members claim rewards
on <span class=GramE>an</span> completed and/or paid transaction if they forgot
for whatever reason to log into their account to place an online order. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>The member is limited to one profile defined by
  email and his or her legal name and it should be understood that the member
  shares their Individual Information with The Store and SHOP ACHAT. The
  information provided can be used to present information, products, services,
and relevant offers from The Store and its associated partners. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>The member is solely responsible for maintaining
  valid Individual Information. The Store cannot be held responsible for any expired
  or error or omission related to the information in the member’s profile.<span
style='mso-spacerun:yes'>  </span>Information on the rewards available for each
member can be found partly in The Store’s Application member profile page on The
Store’s website. Each user, member on The Store’s loyalty Program, The Store’s
Application and SHOP ACHAT cannot share his or her account information with
anyone and should not disclose their password to anyone. The customer who
cannot provide a valid email address cannot participate in the <span
class=GramE>Program,</span> a valid email is required to complete the profile
to become a member. Rewards to purchases made on SHOP ACHAT or The Store’s
Application can only be attributed once the user has successfully linked their
loyalty/rewards Program to the Application. All purchases conducted without the
established connection will not be eligible for rewards. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>The member’s Program card is not a method of
  payment or the equivalent of a credit card. It serves only to permit members to
  access their account, cards including their accumulated rewards that can be
  applied on purchases. SHOP ACHAT and The Store reserve the right to cancel all
  rewards accumulated in an account for which its suspects they were fraudulently
  accumulated. In the event an order through the Application is cancelled, the
  allocation of rewards to the member’s account will be reversed. In the case of
  payment by reward, the rewards will be put back into the member’s account and
  the account may be subject to fraud. Any questions regarding the member’s
  loyalty account should be addressed with the customer service department of The
Store. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>GOVERNING LAWS<br>
</span></b><span style='font-size:10.0pt;font-family:"Arial","sans-serif";
mso-fareast-font-family:"Times New Roman";mso-fareast-language:EN-CA'>This
agreement shall be governed by and construed in accordance with the laws of the
Province of Québec and the applicable laws of Canada therein and, with regards
to conflicts from these terms, parties by the following subject themselves to
the jurisdiction of the courts of the Province of Quebec in the City of Laval.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>DISCLAIMER<br>
</span></b><span style='font-size:10.0pt;font-family:"Arial","sans-serif";
mso-fareast-font-family:"Times New Roman";mso-fareast-language:EN-CA'>THE
APPLICATION MAY INCLUDE TECHNICAL INACCURACIES OR TYPOGRAPHICAL ERRORS. THE STORE
MAY MAKE CHANGES OR IMPROVEMENTS AT ANY TIME. THE APPLICATION AND ALL MATERIALS
THEREIN ARE PROVIDED “AS IS,” “ON THE BASIS OF THEIR AVAILABILITY” AND WITHOUT
WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, TO THE FULLEST EXTENT PERMITTED BY
APPLICABLE LAWS IN FORCE. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>YOU ASSUME THE ENTIRE COST OF
  NECESSARY SERVICING OR REPAIRS. THE ABOVE EXCLUSION MAY NOT APPLY TO YOU, TO
  THE EXTENT THAT APPLICABLE LAW MAY NOT ALLOW THE EXCLUSION OF IMPLIED
  WARRANTIES. YOU ASSUME TOTAL RESPONSIBILITY FOR YOUR USE OF THE APPLICATION. YOUR
  ONLY RECOURSE AGAINST THE STORE IN THE EVENT YOU ARE DISSATIFIED WITH THE
APPLICATION OR ANY CONTENT IS TO STOP USING THE APPLICATION AND ANY CONTENT. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>THE STORE disclaims any liability whatsoever, and
  for any consequences or damage resulting, directly or indirectly, in relation
  to product’s materials used by the Store in the manufacturing of products or
  services sold. SHOP ACHAT and The Store ensure that each store uses quality
  products, but it is your responsibility to report any specific requirements and
dissatisfaction directly to the Store. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>RESTRICTIONS OF LIABILITY<br>
  <br>
</span></b><span style='font-size:10.0pt;font-family:"Arial","sans-serif";
mso-fareast-font-family:"Times New Roman";mso-fareast-language:EN-CA'>SHOP
  ACHAT, THE STORE AND ITS AFFILIATES WILL NOT BE LIABLE FOR ANY DAMAGES OR
  INJURY CAUSED BY ANY USE OR INABILITY TO USE THE APPLICATION, INCLUDING, BUT
  NOT LIMITED TO, ANY FAILURE OF PERFORMANCE, ERROR, OMISSION, INTERRUPTION,
DEFECT, DELAY TRANSMISSION, COMPUTER VIRUS OR FAILURE OF TRANSMISSION LINE. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>SHOP ACHAT, THE STORE AND ITS AFFILIATES WILL NOT
  BE LIABLE FOR ANY DAMAGES OR INJURY, INCLUDING BUT NOT LIMITED TO SPECIAL,
  INCIDENTAL OR CONSEQUENTIAL DUE TO THE USE OR INABILITY TO USE, THE STORE, EVEN
  IF THERE IS NEGLIGENCE ON THE PART OF THE STORE AND ITS AFFILIATES OR THE STORE
  OR AUTHORIZED REPRESENTATIVE OF THE STORE HAS BEEN ADVISED OF THE POSSIBILITY
  OF DAMAGES, OR IF BOTH SITUATIONS HAVE OCCURRED. THE ABOVE LIMITATIONS,
  EXCLUSIONS AND LIABILITY MAY NOT APPLY TO YOU TO THE EXTENT PERMITTED BY
APPLICABLE LAW. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>SHOP ACHAT AND THE STORE’S TOTAL LIABILITY TO YOU
  FOR ANY LOSS, DAMAGE AND INTENTIONS OF ACTION WHETHER IN CONTRACT, TRANSACTION
  (INCLUDING BUT NOT LIMITED TO, NEGLIGENCE), OR OTHERWISE SHALL BE THE LESSER OF
  (I) THE AMOUNT YOU PAID TO USE THE APPLICATION, OR (II) IF APPLICATION WAS
  FREE, THE LUMP SUM OF $1 CAD. <s></s></span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><b><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>TERMINATION<br>
</span></b><span style='font-size:10.0pt;font-family:"Arial","sans-serif";
mso-fareast-font-family:"Times New Roman";mso-fareast-language:EN-CA'>The Store
  may terminate, at its sole discretion, at any time, for any reason and without
  giving you prior notice by putting the Application out of service. You may
  terminate these terms at any time by uninstalling the application from your device
or by ceasing to use the Application on the Store’s website.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>AGREEMENT<br>
</span></b><span style='font-size:10.0pt;font-family:"Arial","sans-serif";
mso-fareast-font-family:"Times New Roman";mso-fareast-language:EN-CA'>These terms,
including all additions and all updates, constitute the entire agreement
between the parties regarding the use of the Application. SHOP ACHAT and The Store
may revise these terms at any time and in <span class=GramE>its</span> to their
sole discretion to change the terms in the Application. The changes reflect the
terms published online. The user is responsible to check the terms on an
ongoing basis to ensure that they agree with the changes. By continuing to
access the Application or use after such changes have been published,
constitutes the users acceptance of the changes.<b></b></span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>TRADEMARK AND COPYRIGHT <br>
</span></b><span style='font-size:10.0pt;font-family:"Arial","sans-serif";
mso-fareast-font-family:"Times New Roman";mso-fareast-language:EN-CA;
mso-bidi-font-weight:bold'>SHOP ACHAT and The Store’s intellectual property</span><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>: The trademarks, logos, icons
and illustrations of the products used in the Application include the
registered trademarks, unregistered trademarks and copyrights of the Store and
its affiliates. The content, website design and Application, including text,
images and documents, are protected by copyright laws. No reproduction or
redistribution of the website and/or the Application, in whole or in part, <span
class=GramE>are</span> permitted without the prior express written consent of
the Store or SHOP ACHAT. All other trademarks used in the application are the
property of their respective owners.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>PRIVACY AND SUPPORT SERVICES<br>
</span></b><span class=GramE><span style='font-size:10.0pt;font-family:"Arial","sans-serif";
mso-fareast-font-family:"Times New Roman";mso-fareast-language:EN-CA'>All</span></span><span
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'> questions and concerns about the
Application or privacy of your Individual Information should be directed to SHOP
ACHAT or The Store’s website and its online customer service forms. You may <span
style='mso-bidi-font-weight:bold'>contact SHOP ACHAT by email
service.ca or by phone at 1-888-899-8897.</span></span></p>
</div>
</ion-content>
}

@if (lang === 'fr' || lang === 'FR') {
  <ion-content>
    <div class=WordSection1>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA;mso-bidi-font-weight:bold'>SHOP ACHAT vous offre une
        expérience de magasinage chez votre marchand favori. Ce qui suit vise à assurer
        votre satisfaction et votre compréhension du processus d’achat des produits et
        services offerts par les marchands qui utilisent SHOP ACHAT, ci-après appelés individuellement,
      le «&nbsp;Marchand&nbsp;», et collectivement, les «&nbsp;Marchands&nbsp;»).</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA;mso-bidi-font-weight:bold'>Lorsque vous effectuez un
        achat pour un produit ou un service d’un Marchand situé aux États-Unis ou au
        Canada, SHOP ACHAT gère le système de commande en ligne situé directement sur
        le site web du Marchand. Votre commande passe par la solution en ligne de SHOP
        ACHAT, qui collecte le paiement pour le compte du Marchand en passant par un
        portail de paiement sécurisé. Tous les prix pour produits ou services sont
        offerts dans la devise locale du Marchand et sont assujettis aux taxes
        applicables. Les produits ou services offerts par le Marchand peuvent être
        sujets à des frais applicables aux commandes <a name="_Hlk43026908">et/ou</a> au
        processus de commande, pour chaque commande passée en ligne ou par
        l’application, et ne sont pas remboursables. Dans plusieurs cas, ces frais
        seront appliqués par le Marchand ou par SHOP ACHAT. Dans tous les cas, si vous
        ne désirez pas payer ces frais de commande, vous pouvez passer votre commande
        par téléphone directement chez le Marchand. Tous les achats sont sujets à
        approbation du crédit et vérification du titulaire de la carte, de l’adresse et
        du code postal de facturation, du numéro de vérification de la carte de crédit
        (Cardholder Verification Value [CVV] code) et de la présentation de ladite
        carte ainsi que l’adresse de facturation respective lors de la cueillette ou de
      la livraison. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b style='mso-bidi-font-weight:normal'><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>Modalités de SHOP ACHAT </span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b style='mso-bidi-font-weight:normal'><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>SHOP ACHAT et les modalités du Marchand</span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif"'></span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif"'>LES PRÉSENTES MODALITÉS ET CONDITIONS
      D’UTILISATION PEUVENT ÊTRE MODIFIÉES OCCASIONNELLEMENT. IL EST DONC IMPORTANT
    DE VOUS TENIR AU COURANT DES MODALITÉS DE </span><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA;mso-bidi-font-weight:bold'>SHOP
    ACHAT. EN UTILISANT LE SITE WEB OU L’APPLICATION DE SHOP ACHAT, AINSI QUE
    L’APPLICATION MOBILE ET LES PRODUITS/SERVICES DU MARCHAND, VOUS RECONNAISSEZ
    VOTRE RESPONSABILITÉ ET ACCEPTEZ LES MODALITÉS ÉNUMÉRÉES CI-DESSOUS. SI UNE OU
    DES MODALITÉS SUIVANTES Ne SONT PAS RESPECTÉES ET ACCEPTÉES POUR QUELQUE RAISON
    QUE CE SOIT, VOUS NE DEVRIEZ PAS UTILISER LES SERVICES DE SHOP ACHAT OU DU
    MARCHAND.</span><span lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif"'></span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif"'>EN ACCÉDANT À, TÉLÉCHARGEANT, INSTALLANT OU
      UTILISANT CETTE APPLICATION D’UNE QUELCONQUE FAÇON, VOUS DONNEZ VOTRE ACCORD ET
      ACCEPTEZ LES PRÉSENTES MODALITÉS. SI VOUS NE LES ACCEPTEZ PAS, N’ACCÉDEZ PAS,
      NE TÉLÉCHARGEZ PAS, N’INSTALLEZ PAS OU N’UTILISEZ PAS L’APPLICATION. SI VOUS
      AVEZ INSTALLÉ L’APPLICATION ET N’ACCEPTEZ PAS CES MODALITÉS, VOUS DEVEZ
    IMMÉDIATEMENT DÉSINSTALLER L’APPLICATION. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>CES MODALITÉS CONSTITUENT UN ACCORD LÉGAL ENTRE
      VOUS, <span style='mso-bidi-font-weight:bold'>SHOP ACHAT ET LE MARCHAND (L’«&nbsp;ENTENTE&nbsp;»).
      CET ACCORD INCLUT DES DISPOSITIONS QUI LIMITENT LA RESPONSABILITÉ DE SHOP ACHAT
    ET DU MARCHAND.</span></span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>&nbsp;</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><b><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>ADMISSIBILITÉ</span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>L’APPLICATION DOIT SERVIR UNIQUEMENT AUX PERSONNES
      DE QUATORZE (14) ANS ET PLUS. SI VOUS AVEZ MOINS DE 14 ANS, VOUS DEVEZ
    IMMÉDIATEMENT CESSER D’UTILISER ET DÉSINSTALLER L’APPLICATION.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:2'><b><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>COLLECTE, UTILISATION ET
    DIVULGATION DE VOS DONNÉES PERSONNELLES</span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:2'><b><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>COLLECTE</span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Vous acceptez que SHOP ACHAT et le Marchand puissent
      recueillir et utiliser vos informations personnelles, votre appareil, son
      système d’exploitation et l’Application. Ceci permet à SHOP ACHAT et au
      Marchand de mieux répondre à vos besoins. En utilisant l’application
      (Application), vous reconnaissez et consentez à ce que SHOP ACHAT et le
      Marchand, et/ou ses affiliés et autres partenaires, puissent recueillir,
      utiliser et transmettre les informations que vous fournissez en utilisant
      l’Appplication, et toute autre information pouvant servir à vous identifier,
      recueillie par l’entremise de l’Application ou spécifiquement transmise par
      vous lorsque vous utilisez l’Application afin de créer un compte chez SHOP
      ACHAT ou chez le Marchand, ou fournie d’autre façon («&#8201;INFORMATIONS
      PERSONNELLES&#8201;») dans le but d’encourager les améliorations et la
      livraison de produits, d’offres, de promotions ou de tout autre service.<b></b></span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span lang=FR-CA style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Information sur la localisation</span></b><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>&nbsp;: avec votre consentement,
      SHOP ACHAT et le Marchand recueillent des informations géographiques par
      l’entremise de l’Application, incluant des informations sur le lieu,
      recueillies grâce à la technologie de géolocalisation ou tout autre technologie
      similaire de votre appareil ou téléphone mobile. Le but de la cueillette
      d’informations géographiques est d’identifier les lieux les plus près de votre
      position immédiate et d’utiliser efficacement les fonctions de l’Application.
      Nous ne recueillons l’information sur la localisation que si vous acceptez, par
      une option d’abonnement, d’avoir certaines fonctions de l’Application et en
      activant ces fonctions sur votre appareil mobile. Une fois que l’abonnement est
      valide, l’Application continuera à recueillir les informations géographiques
      jusqu’à ce que vous fermiez l’Application ou si vous changez les paramètres de
      votre téléphone ou autre appareil afin de désactiver la technologie de
      géolocalisation ou si vous changez les paramètres de votre téléphone ou autre
      appareil afin d’empêcher l’Application de recueillir vos informations
    géographiques. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><b><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>Utilisation</span></b><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>&nbsp;: les INFORMATIONS
    PERSONNELLES sont utilisées dans le but de l’amélioration des fonctions et caractéristiques
    de l’Application permettant de répondre à vos questions et messages, la
conduite de recherches sur le comportement <span style='mso-bidi-font-weight:
bold'>et/ou</span> les intérêts des consommateurs, et afin d’améliorer nos services
  ou produits et de vous informer sur nos offres et promotions en magasin.<span
style='mso-spacerun:yes'>  </span></span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><b><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>Divulgation</span></b><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>&nbsp;: SHOP ACHAT et le Marchand
peuvent partager les INFORMATIONS PERSONNELLES avec leurs filiales, agents,
partenaires d’affaires, franchisés, magasins et autres tierces parties des
façons suivantes&nbsp;: SHOP ACHAT et le Marchand peuvent divulguer de
l’information au sujet de l’information que vous avez accepté de partager par
votre utilisation de l’Application ou lors de visite en magasin, des produits
que vous regardez et partagez le plus fréquemment, et des sections du magasin que
vous visitez le plus fréquemment&nbsp;: SHOP ACHAT et le Marchand peuvent
divulguer les INFORMATIONS PERSONNELLES afin de fournir certains services
commerciaux et de communiquer tel qu’autorisé afin que certains services
commerciaux soient fournis. SHOP ACHAT et le Marchand peuvent divulguer des
INFORMATIONS PERSONNELLES si requis par la loi ou si nous pensons en toute
bonne foi que cela est nécessaire pour (i) nous conformer à nos obligations
légales, (ii) protéger ou défendre nos droits ou notre propriété, (iii) agir
lors de circonstances urgentes afin de préserver la sécurité des utilisateurs
de l’Application ou du grand public, ou (iv) protéger SHOP ACHAT et le Marchand
contre toute responsabilité civile.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><b><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>Stockage de l’information</span></b><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>&nbsp;: SHOP ACHAT et le Marchand
peuvent emmagasiner toute l’information recueillie (autorisée ou autrement)
dans des bases de données qui sont la propriété de et sont entretenues par SHOP
ACHAT, nos filiales, nos fournisseurs, nos franchisés, nos magasins, nos agents
ou nos fournisseurs de services. En utilisant l’Application, vous consentez à
l’enregistrement et au transfert de vos informations tel que décrit ci-haut. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><b><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>La collecte d’information&nbsp;: </span></b><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>vous ne pouvez pas utiliser
l’Application sans fournir des informations personnelles. Vous pouvez
restreindre les informations personnelles recueillies en désinstallant
l’Application, en la fermant ou l’empêchant d’utiliser la fonction de
géolocalisation, ou en limitant certaines fonctions ou caractéristiques de
l’Application par les paramètres de tout appareil mobile.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span lang=FR-CA style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>&nbsp;</span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span lang=FR-CA style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Liens vers d’autres sites web</span></b><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>&nbsp;: l’Application peut
contenir des références, liens ou interactions avec d’autres sites web qui ne
sont pas exploités ou contrôlés par SHOP ACHAT ou le Marchand. Les politiques
et procédures décrites ici ne sont pas applicables aux autres sites web. Ni SHOP
ACHAT ni le Marchand n’assument aucune responsabilité au sujet des politiques
de protection des informations personnelles et de cueillette d’information de
ces sites web.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><b><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>ENVOI DE COMMANDES</span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Cette section s’applique aux commandes passées par
  vous par l’entremise de l’Application là ou le service est offert. Le Marchand
  est la propriété et est géré par un ou plusieurs entrepreneurs
  indépendants&nbsp;: malgré qu’il peut y avoir un organisme parent opérant et
  contrôlant l’Application, il n’est pas responsable des opérations du Marchand.
  Chaque Marchand est pleinement et indépendamment responsable pour sa conformité
  réglementaire et juridique concernant les problèmes en lien avec vous pour les
produits ou services offerts. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span lang=FR-CA style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Commandes&nbsp;</span></b><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>: le but de la fonction Commander
est d’offrir aux clients une façon pratique de créer des commandes à l’avance
pour des produits et de les soumettre en s’enregistrant chez un Marchand
participant. Avant de passer une commande, vous devez créer un profil dans
l’Application. Avant de soumettre une commande, vous devez enregistrer une
carte de crédit (une carte de crédit) sur laquelle les paiements de vos
commandes seront portés. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span lang=FR-CA style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Méthode de paiement</span></b><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>&nbsp;: SHOP ACHAT et le Marchand
comptent sur les services de fournisseurs indépendants pour enregistrer votre carte
de crédit et effectuer les paiements sur SHOP ACHAT. Vous comprenez et acceptez
que lorsque vous enregistrez une carte de crédit, SHOP ACHAT et ses
fournisseurs indépendants se réservent le droit de vérifier la validité de la carte
de crédit enregistrée. Vous comprenez et acceptez également que, lorsque vous passez
une commande en magasin, le Marchand est le magasin. Afin d’effectuer la
cueillette de votre commande en magasin ou lors de la livraison, vous devrez
présenter la carte de crédit ayant servi au paiement ainsi qu’une pièce
d’identité avec photo. Ces pièces d’identité sont essentielles afin de recevoir
votre commande. SHOP ACHAT et le Marchand se réservent le droit de ne pas
remettre ou livrer une commande à quiconque n’ayant pas lesdits documents. VOUS
CERTIFIEZ AVOIR LES DROITS LÉGAUX D’UTILISER LES CARTES DE CRÉDIT QUE VOUS
ENREGISTREZ.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span lang=FR-CA style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Acheter des produits</span></b><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>&nbsp;: lorsque vous passez une
commande, vous la passez directement chez un Marchand participant et l’entente
dans le but de fournir des produits ou services sera conclue entre vous et le
Marchand qui reçoit votre commande. Le magasin où vous ferez la cueillette de
votre commande est responsable de la préparation de vos produits et de vous les
remettre. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span lang=FR-CA style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>À propos des produits</span></b><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>&nbsp;: tout produit est sous
réserve de disponibilité chez le Marchand au moment de la cueillette de votre
commande. Certains Marchands n’offrent pas tous les produits. Les images des
produits et de l’emballage représentés dans l’Application sont à titre
représentatif seulement et peuvent ne pas être identiques aux produits ou
emballages que vous recevrez du Marchand. Les différences peuvent être dues à
l’affichage des couleurs de votre appareil ou autres facteurs, tels que le
fournisseur, la région où se trouve le Marchand, etc. Chaque Marchand mettra et
gardera à jour son inventaire de produits ainsi que leurs descriptions, titres,
images et prix respectifs. Chaque Marchand applique les prix affichés dans la fonction
de commande puis y ajoute toute taxe et tout coût additionnel requis par la
loi. Certaines offres et certains prix peuvent ne pas être disponibles sur
toutes les commandes et chez tous les Marchands. Si vous remarquez une erreur
de prix sur un produit que vous avez acheté, veuillez contacter le Marchand
chez qui vous avez fait l’achat du produit afin de demander un remboursement ou
un crédit au montant de la différence de prix.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span lang=FR-CA style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Traitement des commandes</span></b><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>&nbsp;: Les commandes sont
traitées par l’entremise d’un service développé et alimenté par SHOP ACHAT.
Dans plusieurs cas, les frais d’Application et les frais d’expédition seront dus
à et facturés par SHOP ACHAT, qui offre un service différent de celui offert
par le Marchand. SHOP ACHAT offre un service indépendant que le client peut
choisir d’utiliser afin de passer une commande chez le Marchand. Dans tous les
cas, vous pouvez choisir d’utiliser la fonction de commande de SHOP ACHAT afin
de passer une commande chez le Marchand. Si vous ne voulez pas payer le frais
d’utilisation de la fonction de commande de l’Application, vous pouvez toujours
passer votre commande par téléphone ou en personne directement chez le Marchand
choisi.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span lang=FR-CA style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Envoi de votre commande&nbsp;</span></b><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>: Vous pouvez utiliser
l’Application pour créer votre commande et l’envoyer au Marchand de votre
choix. Votre achat ne sera officiel que lorsque vous soumettrez votre commande
au Marchand. Votre carte de crédit ne sera pas débitée jusqu’à ce que vous ayez
accepté d’envoyer votre commande au Marchand. Les commandes peuvent être
recueillies en personne chez le Marchand ou grâce au service de livraison ou
d’expédition du Marchand.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b><span lang=FR-CA style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Paiement&nbsp;</span></b><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>: Au moment de passer votre
commande, vous acceptez que le Marchand procède au paiement complet de votre
commande. Le fournisseur de service de paiement de SHOP ACHAT ou du Marchand
débitera le montant total de votre commande à la carte de crédit de votre choix
au moment de votre commande. Vous pourriez recevoir un courriel de confirmation
vous informant que votre commande a été approuvée ou que le Marchand a accepté
votre commande et a commencé à la préparer. Les produits vous appartiennent dès
que vous en faites la cueillette ou en recevez la livraison. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b style='mso-bidi-font-weight:normal'><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>Confirmation&nbsp;</span></b><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA;mso-bidi-font-weight:bold'>: Si
vous ne recevez pas un numéro de confirmation (en tant que page de confirmation
et/ou</span><span lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";
mso-fareast-font-family:"Times New Roman";mso-fareast-language:EN-CA'> de<span
style='mso-bidi-font-weight:bold'> courriel) après avoir soumis les
informations de paiement, vous n’avez pas complété votre commande. Si vous faites
une erreur ou subissez une interruption de service après avoir soumis les
informations de paiement, il est de votre responsabilité de confirmer si votre
commande a été passée ou non, par l’entremise de </span>SHOP ACHAT ou du
service à la clientèle du Marchand. Vous êtes la seule personne qui a la
possibilité de voir les problèmes qui peuvent être survenus lors du traitement
de la commande. SHOP ACHAT et le Marchand ne peuvent pas être tenus
responsables pour toute perte (monétaire ou autre) ou tout délai de paiement,
de commande ou de livraison de votre commande, si vous avez assumé qu’une
commande a été passée, mais que vous n’avez pas reçu de confirmation. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Annulation de votre commande&nbsp;: Vous pouvez
  annuler votre commande avant de confirmer votre paiement sur le site web du
  Marchand. Par contre, une fois que le paiement est fait, vous ne pourrez plus
  annuler votre commande. Si vous désirez être remboursé(e) pour quelque raison
  que ce soit, particulièrement si les produits ne sont pas à votre satisfaction
  ou pour toute autre raison, veuillez contacter le Marchand d’où le produit a
  été commandé afin d’obtenir un remboursement. Vos droits légaux à ce sujet ne
sont affectés par aucune de ces modalités. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><b><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>OFFRES DANS L’APPLICATION</span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>Vous pourriez recevoir des offres
promotionnelles par l’entremise de l’APPLICATION. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Les conditions générales suivantes s’appliquent aux
  offres&nbsp;: l’offre est sujette à la disponibilité, chez le Marchand
  seulement, jusqu’à la date d’expiration; sauf stipulation contraire, chaque offre
  expire lorsque le produit est acheté, seulement une offre pouvant être
  appliquée au moment de l’achat chez le Marchand, les offres sont non transférables
  et les offres ne peuvent pas être monnayées. De plus, des conditions
  spécifiques peuvent être applicables à l’offre présentée dans l’Application et
affichées conjointement à l’offre. </span><span style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-ansi-language:EN-CA;mso-fareast-language:EN-CA'>Not all offers that can be
applied to pickup or delivery orders. </span><span lang=FR-CA style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Toute question au sujet des offres devrait être adressée
au Marchand. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><b style='mso-bidi-font-weight:normal'><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>PROGRAMME DE FIDÉLITÉ DANS L’APPLICATION</span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Si le programme de fidélité est actif, il est la
  propriété du Marchand et est disponible pour les clients en collaboration avec
  les Marchands participants. Le Marchand peut, à sa seule discrétion, suspendre
  ou cesser d’offrir le Programme sans préavis. En cas d’interruption ou de cessation
  du Programme pour quelque raison que ce soit, le Marchand et SHOP ACHAT ne
  seront pas tenus responsables envers les membres du Programme et seront
  automatiquement libérés de toute demande des membres dans l’éventualité que le
  Programme soit interrompu, ne soit plus offert, change de modalités ou
  conditions, lors de perte ou d’échange de points ou tout autre problème venant
de l’opération, l’interruption ou cessation du Programme.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Le client-membre est sujet aux modalités et
  conditions, règles, bénéfices, conditions de participation ou prix en points/avantages
  monétaires requis afin d’obtenir une récompense, en tout ou en partie, à tout
  moment et sans préavis, même si ces changements affectent la valeur des points
  accumulés du programme de loyauté du Marchand. Si le programme de loyauté du
  Marchand requiert l’enregistrement de la carte du client afin de réclamer la
  valeur de leur récompense, alors le client doit enregistrer la carte, valider
  et accepter les modalités et conditions du programme tel qu’indiqué sur le site
  web du Marchand, avant de lier leur abonnement à l’Application du Marchand afin
  de l’utiliser comme forme de paiement. Afin d’accumuler des récompenses-points
  — dollars d’avantages lors d’une commande, l’utilisateur-membre doit se
  connecter à son compte afin de passer une commande en ligne sur SHOP ACHAT ou
  sur l’Application du Marchand. En aucun cas un membre ne peut réclamer une
  récompense pour une transaction complétée et/ou payée s’ils-elles ont oublié
  pour quelque raison que ce soit d’enregistrer dans leur compte afin de passer
la commande en ligne. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Le membre est limité à un profil défini par adresse
  courriel et nom légal, et il doit être clair que le membre partage ses
  Informations Personnelles avec le Marchand et SHOP ACHAT. L’information fournie
  peut être utilisée afin de présenter de l’information, des produits, services
et offres appropriées, du Marchand et de ses partenaires associés. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Le membre est l’unique responsable du maintien de
  la validité de ses INFORMATIONS PERSONNELLES. Le Marchand ne peut pas être tenu
  responsable de toute expiration ou erreur ou omission en lien avec les
  informations inclues dans le profil du membre. Les informations à propos des
  récompenses disponibles pour chaque membre peuvent être trouvées en partie dans
  la page de profil du membre, dans l’Application du Marchand ou sur son site
  web. Chaque utilisateur membre du Programme de fidélité du Marchand, de
  l’Application du Marchand et de SHOP ACHAT ne peut pas partager ses
  informations avec qui que ce soit et ne doit pas révéler son mot de passe à
  quiconque. Un client ne pouvant pas fournir une adresse courriel valide ne peut
  pas participer au Programme, une adresse courriel étant requise afin de
  compléter le profil et de devenir membre. Les récompenses pour les achats faits
  sur SHOP ACHAT ou chez le Marchand ne peuvent être attribuées qu’à partir du moment
  ou l’utilisateur a lié son Programme de fidélité à l’Application avec succès.
  Tout achat fait sans l’entremise de cette connexion établie ne sera pas
admissible aux récompenses. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>La carte de membre du Programme n’est pas une
  méthode de paiement ou l’équivalent d’une carte de crédit. Elle ne sert qu’à
  titre de permis aux membres dans le but d’accéder à leur compte, les cartes
  incluant les récompenses accumulées pouvant être appliquées aux achats. SHOP ACHAT
  et le Marchand se réservent le droit d’annuler toute récompense accumulée dans
  un compte pour lequel les récompenses sont suspectées d’être accumulées par la
  fraude. Dans le cas où une commande passée par l’entremise de l’Application est
  annulée, l’allocation de récompenses au compte du membre sera renversée. Dans
  le cas d’un paiement par les récompenses, les récompenses seront remises au
  compte du membre et le compte sera suspecté de fraude. Toute question au sujet
  d’un compte du Programme de fidélité d’un membre devra être transmise au
  Service à la Clientèle du Marchand.<span style='mso-spacerun:yes'>  </span></span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>LOIS APPLICABLES</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Cette entente sera régie et interprétée
    conformément aux lois de la province de Québec et des lois applicables du
    Canada et, en ce qui concerne des conflits entre ces modalités, les parties par
    la suivante acceptent de se soumettre à la juridiction des tribunaux de la
  province de Québec, à la ville de Laval. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;page-break-after:avoid;mso-outline-level:
3'><span lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";
mso-fareast-font-family:"Times New Roman";mso-fareast-language:EN-CA'>AVIS DE
  NON-RESPONSABILITÉ</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;page-break-after:avoid;mso-outline-level:
3'><span lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";
mso-fareast-font-family:"Times New Roman";mso-fareast-language:EN-CA'>CETTE
    APPLICATION PEUT INCLURE DES IMPRÉCISIONS TECHNIQUES OU ERREURS TYPOGRAPHIQUES.
    LE MARCHAND PEUT FAIRE DES CHANGEMENTS OU AMÉLIORATIONS À TOUT MOMENT.
    L’APPLICATION ET TOUT MATÉRIEL INCLUS SONT FOURNIS «&#8201;TELS QUELS&#8201;»,
    «&#8201;SUR LA BASE DE LEUR DISPONIBILITÉ&#8201;» ET SANS GARANTIES DE QUELQUE
    NATURE, EXPRIMÉES OU SOUS-ENTENDUES, DANS LA MESURE OU LA LOI APPLICABLE EN
  VIGUEUR LE PERMET.</span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal;mso-outline-level:3'><span lang=FR-CA
style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>VOUS ASSUMEZ LE COÛT TOTAL DES
    RÉPARATIONS OU ENTRETIENS NÉCESSAIRES. L’EXCLUSION CI-HAUT POURRAIT NE PAS ÊTRE
    APPLICABLE À VOUS, DANS LA MESURE OÙ LA LOI APPLICABLE POURRAIT NE PAS
    PERMETTRE L’EXCLUSION DES GARANTIES SOUS-ENTENDUES. VOUS ASSUMEZ L’ENTIÈRE
    RESPONSABILITÉ DE L’UTILISATION DE L’APPLICATION. VOTRE SEUL RECOURS CONTRE LE
    MARCHAND EN CAS D’INSATISFACTION AU SUJET DE L’APPLICATION OU DE QUELQUE
  CONTENU QUE CE SOIT EST D’ARRÊTER D’UTILISER L’APPLICATION ET SON CONTENU. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>LE MARCHAND refuse toute responsabilité que ce
    soit, pour toute conséquence ou tout dommage résultant, directement ou
    indirectement, en lien avec les matériaux des produits utilisés par le Marchand
    dans la production des produits ou services vendus. SHOP ACHAT et le Marchand
    s’assurent que chaque magasin utilise des produits de bonne qualité, mais il
    est de votre responsabilité de signaler toute exigence spécifique et
  insatisfaction directement au Marchand. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b><span lang=FR-CA style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>LIMITATIONS DE RESPONSABILITÉ</span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>SHOP ACHAT, LE MARCHAND ET SES FILIALES NE PEUVENT
    ÊTRE TENUS RESPONSABLES DE QUELQUE DOMMAGE OU BLESSURE QUE CE SOIT, CAUSÉE PAR
    L’UTILISATION OU LA MAUVAISE UTILISATION DE L’APPLICATION, INCLUANT, MAIS SANS
    S’Y LIMITER, TOUT ÉCHEC DE PERFORMANCE, ERREUR, OMISSION, INTERRUPTION, DÉFAUT,
    DÉLAI DE TRANSMISSION, VIRUS INFORMATIQUE OU DÉFAILLANCE DES LIGNES DE
  TRANSMISSION. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>SHOP ACHAT, LE MARCHAND ET SES FILIALES NE PEUVENT
    ÊTRE TENUS RESPONSABLES DE QUELQUE DOMMAGE OU BLESSURE SUBI(E), INCLUANT, MAIS
    NE SE LIMITANT PAS AUX DOMMAGES SPÉCIAUX, INDIRECTS OU CONSÉCUTIFS, DUS À
    L’UTILISATION OU LA MAUVAISE UTILISATION DU MAGASIN, MÊME S’IL Y A NÉGLIGENCE
    DE LA PART DU MARCHAND OU DE SES FILIALES, OU QUE LE MARCHAND OU SON
    REPRÉSENTANT LÉGAL A ÉTÉ AVISÉ DE LA POSSIBILITÉ DE DOMMAGES, OU SI LES DEUX
    SITUATIONS SE SONT AVÉRÉES. LES LIMITATIONS, EXCLUSIONS ET RESPONSABILITÉS
    CITÉES CI-HAUT POURRAIENT NE PAS S’APPLIQUER À VOUS DANS LA MESURE DE LA LOI
  APPLICABLE. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
text-align:justify;line-height:normal'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>LA RESPONSABILITÉ ENTIÈRE DE SHOP ACHAT ET DU
    MARCHAND ENVERS VOUS POUR TOUTE PERTE, TOUT DOMMAGE ET TOUTE INTENTION D’ACTION
    (QUE CE SOIT DANS LE CONTRAT, LA TRANSACTION [INCLUANT, MAIS MAIS SANS S’Y
    LIMITER, NÉGLIGENCE] OU AUTRE), SERA DU MOINDRE DE (I) LE MONTANT PAYÉ POUR
    UTILISATION DE L’APPLICATION OU (II) SI L’APPLICATION ÉTAIT GRATUITE, LE
    MONTANT UNIQUE DE 1&nbsp;$ CAD. <s></s></span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b><span lang=FR-CA style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>CESSATION</span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Le Marchand peut mettre fin à cette entente, à sa
      seule discrétion, à tout moment et pour quelque raison que ce soit et sans
      préavis, en mettant l’Application hors service. Vous pouvez vous désister de
      ces conditions en tout temps en désinstallant l’Application de votre appareil
      mobile ou en cessant de l’utiliser sur le site web du Marchand. <b></b></span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;page-break-after:avoid;mso-outline-level:3'><b><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>ENTENTE</span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;page-break-after:avoid;mso-outline-level:3'><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>Ces conditions, incluant tout
        ajout et toute mise à jour, constituent l’entente complète entre les parties au
        sujet de l’utilisation de l’Application. SHOP ACHAT et le Marchand peuvent
        réviser ces conditions à tout moment et modifier les conditions dans
        l’Application, à leur seule discrétion. Les modifications reflètent les
        conditions publiées en ligne. L’utilisateur a la responsabilité de vérifier les
        conditions sur une base régulière afin de s’assurer d’être en accord avec les
        modifications. En continuant d’accéder à l’Application ou de l’utiliser après
        que lesdits changements aient été publiés, constitue l’acceptation des
        modifications par l’utilisateur. <b></b></span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b><span lang=FR-CA style='font-size:
10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>MARQUE DE COMMERCE ET DROIT D’AUTEUR</span></b><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'></span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA'>Les éléments qui suivent sont la propriété
        intellectuelle de SHOP ACHAT et du Marchand&nbsp;: les marques de commerce,
        logos, icônes et illustrations des produits utilisés dans l’Application
        incluant les marques de commerce enregistrées, les marques de commerce non enregistrées
        et les droits d’auteur du Marchand et de ses filiales. Le contenu, design du
        site web et l’Application, incluant le texte, les images et documents, sont
        protégés par les lois sur les droits d’auteur. Aucune reproduction ou
        redistribution du site web et/ou de l’Application, en tout ou en partie, ne
        sont permises sans le consentement préalable explicite et écrit du Marchand ou
        de SHOP ACHAT. Toute autre marque de commerce utilisée dans l’Application est
      la propriété de leur propriétaire respectif. </span></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><b style='mso-bidi-font-weight:normal'><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA'>CONFIDENTIALITÉ ET SERVICE DE
      SOUTIEN</span></b></p>
<p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
line-height:normal;mso-outline-level:3'><span lang=FR-CA style='font-size:10.0pt;
font-family:"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";
mso-fareast-language:EN-CA;mso-bidi-font-weight:bold'>Toute question et
        interrogation à propos de l’Application ou de la confidentialité de vos INFORMATIONS
        PERSONNELLES devra être adressée directement à SHOP ACHAT ou sur le site web du
        Marchand et les formulaires de service à la clientèle en ligne. Vous pouvez
      contacter SHOP ACHAT par courriel à l’adresse </span><span lang=FR-CA><a
href="mailto:service@shopachat.ca"><span style='font-size:10.0pt;font-family:
"Arial","sans-serif";mso-fareast-font-family:"Times New Roman";color:windowtext;
mso-fareast-language:EN-CA;mso-bidi-font-weight:bold'>service&#64;shopachat.ca</span></a></span><span
lang=FR-CA style='font-size:10.0pt;font-family:"Arial","sans-serif";mso-fareast-font-family:
"Times New Roman";mso-fareast-language:EN-CA;mso-bidi-font-weight:bold'> ou par
    téléphone au 1-888-899-8897.<span style='mso-spacerun:yes'>  </span></span></p>
    <p class=MsoNormal><span lang=FR-CA>&nbsp;</span></p>
  </div>
</ion-content>
}